import { render, staticRenderFns } from "./CarouselSlideImageView.vue?vue&type=template&id=3b1350d2&scoped=true"
import script from "./CarouselSlideImageView.vue?vue&type=script&lang=js"
export * from "./CarouselSlideImageView.vue?vue&type=script&lang=js"
import style0 from "./CarouselSlideImageView.vue?vue&type=style&index=0&id=3b1350d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1350d2",
  null
  
)

export default component.exports